// frontend/src/components/PaymentCancel.js (NEW FILE)
import React from "react";
import { Link } from "react-router-dom";

function PaymentCancel() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Payment Cancelled</h1>
      <p>Your subscription process was cancelled.</p>
      <p>You can return to the pricing page if you change your mind.</p>
      <Link
        to="/pricing"
        style={{
          marginTop: "20px",
          display: "inline-block",
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          textDecoration: "none",
          borderRadius: "5px",
        }}
      >
        View Pricing
      </Link>
      <br />
      <Link
        to="/"
        style={{ marginTop: "10px", display: "inline-block", color: "#6c757d" }}
      >
        Return Home
      </Link>
    </div>
  );
}

export default PaymentCancel;
